<script setup lang="ts">
import { useMetallicPlansStore } from '@/page/infrastructure/composition/useMetallicPlansStore';
import MetalTierContent from '@/page/infrastructure/views/MetalTierContent.vue';

const props = defineProps<{
  planName: string;
}>();

const { metalPlanPageSections } = useMetallicPlansStore(props.planName);
</script>
<template>
  <MetalTierContent v-if="metalPlanPageSections" :metal-plan-page-sections="metalPlanPageSections" :plan-name="planName">
  </MetalTierContent>
</template>
